import styled from "styled-components";
import { TipMouseOutEvent, TipMouseOverEvent } from "../Tooltip/Tooltip";

function TopRagnarokBrasil() {
    return(
            <VoteContainer>
            <a
                href="https://www.topragnarok.com.br/vote/23959"
                target="_blank"
                title="Vote no servidor TOP">
                <Banner 
                onMouseOver={(event) => TipMouseOverEvent(event, "<b>Votar<br>TopRagnarok Brasil</b>", "rgba(15, 151, 22, 1)")} onMouseLeave={() => TipMouseOutEvent()}

                src="https://www.lionsragnarokserver.net/downloads/banner2-top.png"
                alt="Clique e vote. Top Ragnarok Online Brasil"
                title="Clique e vote. Top Ragnarok Online Brasil"
                border="0"/>
            </a>
            </VoteContainer>
        

    )
}

export default TopRagnarokBrasil;

const VoteContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
`

const H3 = styled.span`
    font-size: 14pt;
    font-weight: bold;
`

const Banner = styled.div`
    margin: 0;
    padding: 0;
    background-image: url(${props => props.src});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 500px;
    height: 63px;
    opacity: 1;
    scale: 1;
    transition: .3s ease-in-out;
    //border: 1px solid white;

    &:hover {
    scale: 1.1;
    box-shadow: 2px 2px 5px 0 black;
    opacity: 1;
    }

     cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`